import { Auth0Provider } from '@auth0/auth0-react';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { ProfiledApp as App } from './App';
import { persistor, store } from './app/store';
import config from './config';
import LoadingPlantPage from './features/pages/LoadingPlantPage';
import './index.css';
import { initSentry } from './initSentry';
import reportWebVitals from './reportWebVitals';
import './services/translation/impl/i18n/index';
initSentry();

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingPlantPage />} persistor={persistor}>
        <BrowserRouter>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <Auth0Provider
              domain='bloomfield-dashboard.us.auth0.com'
              clientId={config.auth0.clientId}
              audience='https://bloomfield.ai/api'
              redirectUri={window.location.origin}
              scope='openid profile email'
            >
              <App />
            </Auth0Provider>
          </QueryParamProvider>
        </BrowserRouter>
      </PersistGate>
    </ReduxProvider>
  </React.StrictMode>
);

reportWebVitals();
